import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../environments/environment';

import { Branch } from './selectable-schema';

@Injectable()
export class SelectablesService {

	private url = environment.url;
	private branchUrl =  this.url + '/branch/all';
	private clientUrl =  this.url + '/clients/all';
	public selected_loading_point:string = 'rail';
	public selected_branch:string=null;
	public selected_client:string=null;
	selected_rr_number :string;
	selected_rr_date :string;

	advance_info : any = null;
	godown_to : string;
	by_godown :boolean =false;
	// private groupsUrl = 'http://139.59.93.243/groups';

	constructor(private http: HttpClient) { }

	getBranches(): Observable<Branch[]> {
		return this.http.get<Branch[]>(this.branchUrl);
	};

	// Set Consigner name at the time of select branch and client go to the rrform
	setConsigner(client:string){
		this.selected_client=client;
	};
	getSelectedLoadPoint(point:string){
		this.selected_loading_point = point;
	};
	getSelectedBranch(branch:string){
		this.selected_branch = branch;
	};
	

	getRRNumber(rr_num:string){
		this.selected_rr_number = rr_num;
		console.log(this.selected_rr_number);
	}
	getRRDate(rr_date:string){
		this.selected_rr_date = rr_date;
		console.log(this.selected_rr_date);
	}

	// getAdvanceInfo(advance_info:any){
	// 	this.advance_info = advance_info;
	// 	console.log(this.advance_info);
	// };

	getGodownToForm(form:string,){
		this.by_godown = true;
		this.godown_to = form;
		console.log(this.godown_to);
	};

	getKmsRate(query : any): Observable<any> {
		return this.http.post<any>(this.url + '/masters/destination/kms', query );
	};

}



// WEBPACK FOOTER //
// /Users/meghneel/work/shree_translogic_dashboard/src/app/selectables.service.ts